import { Component, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Blobs, BlobService } from 'my-lib-sanfelici';

@Component({
  selector: 'app-blob-list',
  templateUrl: './blob-list.component.html',
  styleUrls: ['./blob-list.component.scss']
})
export class BlobListComponent implements OnInit {
  private BlobSource = new Subject<Blobs>();
  blob = this.BlobSource.asObservable();
blobs: Observable<Blobs[]>;
  constructor(private blobservice: BlobService) { }
onClick(blob: Blobs) {
this.BlobSource.next(blob);
}
onDelete(key) {
  this.blobservice.delete(key);

}

  ngOnInit() {
   
    this.blobs = this.blobservice.list();
    this.blobs.subscribe(b=>{
      b.forEach(i=>{
        if(i.createat){
          const d=i.createat;
        }else{
          const c=i.createat;
        }
        
      });
    });
  }

}
